// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DislikeTwoToneSvg from "@ant-design/icons-svg/es/asn/DislikeTwoTone";
import AntdIcon from '../components/AntdIcon';

var DislikeTwoTone = function DislikeTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DislikeTwoToneSvg
  }));
};

DislikeTwoTone.displayName = 'DislikeTwoTone';
export default React.forwardRef(DislikeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DislikeTwoTone.js
// module id = 953
// module chunks = 0